import React, { useEffect, useState } from 'react';
import { NSInput, NSModal } from '../../../../../bricks';
import { useProFormaSocketContext } from '../socketContext/ProFormaSocketProvider';
import { DESCRIPTION_LENGTH_EXCEEDED_MSG, PRO_FORMA_DESCRIPTION_MAX_LENGTH } from './constants';

interface IEditProFormaModalProps {
    showEditProFormaModal: boolean;
    toggleEditProFormaModal: () => void;
}

const EditProFormaModal = ({ showEditProFormaModal, toggleEditProFormaModal }: IEditProFormaModalProps) => {
    const { proForma, handleUpdateProForma } = useProFormaSocketContext();
    const [name, setName] = useState<string>(proForma?.name || '');
    const [description, setDescription] = useState<string>(proForma?.description || '');

    const isDescriptionTooLong = description.length > PRO_FORMA_DESCRIPTION_MAX_LENGTH;

    const handleSave = () => {
        if (isDescriptionTooLong) {
            return;
        }
        handleUpdateProForma(
            [
                { key: 'name', value: name },
                { key: 'description', value: description },
            ],
            toggleEditProFormaModal,
        );
    };

    useEffect(() => {
        setName(proForma?.name || '');
        setDescription(proForma?.description || '');
    }, [proForma]);

    return (
        <NSModal
            isOpen={showEditProFormaModal}
            toggle={toggleEditProFormaModal}
            modalHeaderText="Edit pro forma"
            modalHeaderClassName="text-white bg-primary"
            modalFooterButtonText="Save"
            modalFooterButtonFunction={handleSave}
            modalFooterIsButtonFunctionDisabled={isDescriptionTooLong}
        >
            <NSInput
                label="Name"
                type="text"
                name="name"
                placeholder="Enter pro forma name"
                labelClassName="mb-0"
                value={name}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
                required
            />
            <NSInput
                label="Description"
                type="textarea"
                name="description"
                placeholder="Enter optional description for this pro forma"
                labelClassName="mb-0 mt-2"
                value={description}
                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setDescription(e.target.value)}
                showErrorMsg={isDescriptionTooLong}
                errorMsg={DESCRIPTION_LENGTH_EXCEEDED_MSG}
                dataTestId="edit-pro-forma-description"
            />
            <p
                className={`small mt-1 mb-0 ${isDescriptionTooLong ? 'text-danger' : 'text-muted'}`}
                data-testid="pro-forma-description-char-count"
            >
                {`${description.length} / ${PRO_FORMA_DESCRIPTION_MAX_LENGTH}`}
            </p>
        </NSModal>
    );
};

export default EditProFormaModal;
